import HighlightImportantKpis from '@app/src/pages/Configurations/ConfigurationsPages/Automation/CreationSteps/HighlightImportantKpis/HighlightImportantKpis'
import React from 'react'
import { ExpectationAutomationFormField } from '../types'

const HighlightImportantKpisStep: React.FC<{ assessmentTemplateId: number | undefined }> = ({
  assessmentTemplateId,
}) => (
  <HighlightImportantKpis
    fieldName={ExpectationAutomationFormField.ImportantKpis}
    assessmentTemplateId={assessmentTemplateId}
  />
)

export default HighlightImportantKpisStep
